import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[percent]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PercentValidator, multi: true }],
  standalone: false
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class PercentValidator {
  @Input('percent')
  public active: boolean;

  /**
   * validator to check unique term
   * @param control
   * @returns
   */
  validate(control: AbstractControl): ValidationErrors | null {
    // eslint-disable-next-line eqeqeq
    if (!this.active || !control.value || control.value == '' || control.value == null) {
      return null;
    }

    const value = (control.value || '').replace(/[^\d.]/gi, '');

    // eslint-disable-next-line eqeqeq
    if (value?.length == 0 && value?.length !== control.value?.length) {
      return {
        ['percent']: 'This field requires a percentage value.'
      };
    }

    if (isNaN(+value)) {
      return {
        ['percent']: 'Invalid value.'
      };
    }

    if (+value < 0 || +value > 100) {
      return {
        ['percent']: 'Given value has to be between 0% to 100%.'
      };
    }

    return null;
  }
}
